export default __webpack_public_path__ + "static/project-slide-8-415-700-312560a355a2195d1d79485e44418c73.jpg";